// Every page of the module is under /{tenant}/{CONTRACTS_BASE_PATH}/... (the host mounts
// <Route path=":tenant/contracts/*" element={<ContractsModule />} />). Paths below are relative to it.
export const CONTRACTS_BASE_PATH = 'contracts';

export const CONTRACTS_PAGES = {
    dashboard: '',
    list: 'list',
    create: 'create',
    edit: 'edit/:id',
    show: 'show/:id',
    settings: 'settings',
};
